export const CHECKIN_SUMMARY_SKILL_CARD_SOURCE = 'checkin-summary-skill-card'

export type CheckinSkillOutcome = {
  content: string
  id: string
}
